import { state } from '../index';
function getAllToolGroups() {
    return state.toolGroups;
}
export default getAllToolGroups;
//# sourceMappingURL=getAllToolGroups.js.map